<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="pv"></a><span epub:type="pagebreak" id="pagev" title="v">Contents</span></h2>
<p class="tocl"><a href="#/xhtml/illu">List of Illustrations</a></p>
<p class="tocl1"><a href="#/xhtml/map">Map</a></p>
<p class="tocl"><a href="#/xhtml/prolog">Prologue</a></p>
<p class="toc">  <a href="#/xhtml/chapter01">1.   On the Devil’s Horns</a></p>
<p class="toc">  <a href="#/xhtml/chapter02">2.   A Russian Englishman</a></p>
<p class="toc">  <a href="#/xhtml/chapter03">3.   My Arbat University</a></p>
<p class="toc">  <a href="#/xhtml/chapter04">4.   Who Is Last?</a></p>
<p class="toc">  <a href="#/xhtml/chapter05">5.   Oh! Bananas!</a></p>
<p class="toc">  <span href="#/xhtml/chapter06" title="Link target outside of Sample">6.   Forty Degrees</span></p>
<p class="toc">  <span href="#/xhtml/chapter07" title="Link target outside of Sample">7.   Here Comes the Sun</span></p>
<p class="toc">  <span href="#/xhtml/chapter08" title="Link target outside of Sample">8.   To Red Lighthouse</span></p>
<p class="toc">  <span href="#/xhtml/chapter09" title="Link target outside of Sample">9.   The Unpredictable Past</span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10.   Strange Encounters</span></p>
<p class="toc"><span href="#/xhtml/chapter11" title="Link target outside of Sample">11.   Cold War Walls</span></p>
<p class="toc"><span href="#/xhtml/chapter12" title="Link target outside of Sample">12.   Not Any Other Country</span></p>
<p class="toc"><span href="#/xhtml/chapter13" title="Link target outside of Sample">13.   Oh! Oh! Oh! Oh! Oh!</span></p>
<p class="toc"><span href="#/xhtml/chapter14" title="Link target outside of Sample">14.   Goodbye to Moscow</span></p>
<p class="toc"><span href="#/xhtml/chapter15" title="Link target outside of Sample">15.   Back in the UK</span></p>
<p class="toc"><span href="#/xhtml/chapter16" title="Link target outside of Sample">16.   Lemonade Joe</span></p>
<p class="toc"><span href="#/xhtml/chapter17" title="Link target outside of Sample">17.   Into a Whirlwind</span></p>
<p class="toc"><span href="#/xhtml/chapter18" title="Link target outside of Sample">18.   More Light</span></p>
<p class="toc"><span href="#/xhtml/chapter19" title="Link target outside of Sample">19.   The KGB Makes Friends</span></p>
<p class="toc"><span href="#/xhtml/chapter20" title="Link target outside of Sample">20.   The KGB Closes in</span></p>
<p class="toc"><span href="#/xhtml/chapter21" title="Link target outside of Sample">21.   Baltic Rebirth</span></p>
<p class="toc"><span href="#/xhtml/chapter22" title="Link target outside of Sample">22.   Triumph and Tragedy</span></p>
<p class="toc"><span href="#/xhtml/chapter23" title="Link target outside of Sample">23.   The KGB Gets Me</span></p>
<p class="toc"><span href="#/xhtml/chapter24" title="Link target outside of Sample">24.   Spitting Live Frogs</span></p>
<p class="toc"><span href="#/xhtml/chapter25" title="Link target outside of Sample">25.   Turning off Gorbachev’s Lights</span></p>
<p class="toc"><a id="pvi"></a><span epub:type="pagebreak" id="pagevi" title="vi"><span href="#/xhtml/chapter26" title="Link target outside of Sample">26.   Humiliated and Insulted</span></span></p>
<p class="toc"><span href="#/xhtml/chapter27" title="Link target outside of Sample">27.   No Static at All</span></p>
<p class="toc"><span href="#/xhtml/chapter28" title="Link target outside of Sample">28.   Siberia: The Shaman’s Curse</span></p>
<p class="toc"><span href="#/xhtml/chapter29" title="Link target outside of Sample">29.   Katastroika</span></p>
<p class="toc"><span href="#/xhtml/chapter30" title="Link target outside of Sample">30.   Chechnya</span></p>
<p class="toc"><span href="#/xhtml/chapter31" title="Link target outside of Sample">31.   The Fear of War</span></p>
<p class="toc"><span href="#/xhtml/chapter32" title="Link target outside of Sample">32.   Life is Getting Better, Comrades</span></p>
<p class="toc"><span href="#/xhtml/chapter33" title="Link target outside of Sample">33.   What Kind of Russia?</span></p>
<p class="toc"><span href="#/xhtml/chapter34" title="Link target outside of Sample">34.   Watching from a Distance</span></p>
<p class="toc"><span href="#/xhtml/chapter35" title="Link target outside of Sample">35.   In the Kremlin</span></p>
<p class="toc"><span href="#/xhtml/chapter36" title="Link target outside of Sample">36.   ‘Foreign agent’</span></p>
<p class="tocl1"><span href="#/xhtml/epilog" title="Link target outside of Sample">Epilogue</span></p>
<p class="tocl"><span href="#/xhtml/ack" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="tocl"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4aec325c